import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { LogoMark3D } from './logo/LogoMark3D';
const EASE = [0.23, 1, 0.32, 1] as const;
const TICKS = Array.from({
  length: 72
}, (_, i) => i);
export function HeroLogoMark() {
  const reduce = useReducedMotion();
  return <div className="relative mx-auto aspect-square w-full max-w-[460px]" aria-hidden="true" data-id="element-54" data-mp="3hngo09dk30a7">
      <motion.svg viewBox="0 0 400 400" className="absolute inset-0 h-full w-full" initial={reduce ? false : {
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} data-id="element-55" data-mp="6gpti4ua7yb">
        <circle cx="200" cy="200" r="192" fill="none" stroke="#D9C29A" strokeOpacity="0.3" strokeWidth="1" strokeDasharray="2 7" data-id="element-56" data-mp="963vig4lpzx6" />
        {TICKS.map(i => <line key={i} x1="200" y1={i % 6 === 0 ? 30 : 34} x2="200" y2="40" stroke="#C9AA78" strokeOpacity={i % 6 === 0 ? 0.6 : 0.25} strokeWidth="1" transform={`rotate(${i * 5} 200 200)`} data-id="element-57" data-mp="2ayibh9nl4uay" />)}
        <circle cx="200" cy="200" r="140" fill="none" stroke="#F3EADB" strokeOpacity="0.1" strokeWidth="1" data-id="element-58" data-mp="22b5wb2jppofn" />
      </motion.svg>

      <div className="absolute inset-0 flex items-center justify-center" data-id="element-59" data-mp="279h5rc63hwxc">
        <LogoMark3D className="aspect-[556/300] w-[78%]" depth={18} step={1} perspective={1100} shadow data-id="element-60" data-mp="2c2tv5oilm7r5" />
      </div>
    </div>;
}